import { axiosClientInstance } from '@/lib/servies/axiosConfig';
import { useQuery } from '@tanstack/react-query';

export const apiGetRequest = async (route: string) => {
    try {
        const response = await axiosClientInstance.get(route);
        return response.data;
    } catch {}
};

export default function useFetch(
    key: string,
    url: string,
    cacheTime?: number,
    enabled?: boolean,
) {
    const { data, isError, isLoading, isFetching, refetch } = useQuery({
        queryKey: [key],
        queryFn: async () => apiGetRequest(url),
        staleTime: cacheTime || 1000,
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
        enabled,
    });
    return { data, isError, isLoading, isFetching, refetch };
}
